import { createAsyncThunk } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";
import type { RootState } from "../store/types";
import { getInstanceId } from "./common/serviceUtils";

type RejectFn = (value: string) => unknown;

const handleRequest = async (
  request: () => Promise<AxiosResponse>,
  rejectWithValue: RejectFn,
): Promise<AxiosResponse | unknown> => {
  try {
    const response = await request();
    return response;
  } catch (error) {
    clientLog({
      component: "stopContact",
      message: `Something went wrong => ${error}`,
    });
    logMessage(
      "Stop Contact Callback",
      `Something went wrong => ${error}`,
      "error",
    );
    const err = error as Error;
    return rejectWithValue(`Error: ${err.message}`);
  }
};

const getStopContact = async (
  instanceId: string,
  rejectWithValue: RejectFn,
): Promise<AxiosResponse | unknown> => {
  const request = async (): Promise<AxiosResponse> => {
    return awsClientGateway({
      pathTemplate: `/stopContact/${instanceId}?apiName=stopContact`,
      method: "GET",
    });
  };
  return await handleRequest(request, rejectWithValue);
};

export const getStopContactData = createAsyncThunk<
  unknown,
  void,
  { state: RootState }
>(
  "stopContact/getStopContact",
  async (_args, { getState, rejectWithValue }) => {
    const instanceId = getInstanceId(getState());
    return await getStopContact(instanceId, rejectWithValue);
  },
);

export const deleteStopContact = createAsyncThunk<
  unknown,
  unknown[],
  { state: RootState }
>(
  "/stopContact/deleteStopContact",
  async (deleteAttribute, { getState, rejectWithValue }) => {
    const instanceId = getInstanceId(getState());

    const request = async (): Promise<AxiosResponse> => {
      return awsClientGateway({
        pathTemplate: `/stopContact/${instanceId}`,
        method: "POST",
        body: { records: deleteAttribute },
      });
    };
    return await handleRequest(request, rejectWithValue);
  },
);
